//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
import { uploadImg } from "@/api/uploadImg";
import QueryMap from "@/components/QueryMap/index";
export default {
  name: "CooperativeApplyExamine",
  components: {
    QueryMap,
  },
  data() {
    const validateIdCard = (rule, value, callback) => {
      if (value && value.length != 18) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      cooApplyId: "", //合作社申请id
      centreAddress: "",
      form: {
        applyTime: "", //申请时间
        liaisonName: "", //联系人
        loginMobile: "", //注册手机号
        cooperativeName: "", //合作社名称
        socialCreditCode: "" /*统一社会信用代码*/,
        corName: "" /*法人代表姓名*/,
        corMobile: "" /*法人代表电话*/,
        registeredCapital: null /*出资总额*/,
        foundingTime: null /*成立时间*/,
        address: "" /*详细地址-住所*/,
        businessLicenseUrl: "" /*营业执照url*/,
        provinceId: "" /*省id*/,
        provinceName: "",
        cityId: "",
        cityName: "",
        areaId: "",
        areaName: "",
        identityId: null,
        directorName: null /*理事长姓名*/,
        directorIdCard: null /*理事长身份证号码*/,
        directorAddress: null /*理事长住址*/,
        directorMobile: null /*理事长电话*/,
        directorHeadUrl: null /*理事长头像照片*/,
        cardPortraitUrl: null /*身份证人像url*/,
        cardEmblemUrl: null /*身份证国徽url*/,
        businessZoneId: null /*业务区域id*/,
        businessPersonId: null /*业务员id*/,
        applyStatus: 2 /*状态 2  待审核 3 审核拒绝 4 审核通过*/,
        auditType: "" /*审核类型2-暂存 3-拒绝 4-通过*/,
        centre: "",
      },
      honorFileList: [], //荣誉图片-回显
      cooHonorFileList: [], //荣誉图片
      premisesFileList: [], //经营场地图片-回显
      cooBusinessPlaceFileList: [], //经营场地图片
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,
      rules: {
        cooperativeName: {
          required: true,
          message: "请输入合作社名称",
          trigger: "blur",
        },
        centre: [
          { required: true, message: "请点击编辑所在位置", trigger: "change" },
        ],
        socialCreditCode: {
          required: true,
          message: "请输入统一社会信用代码",
          trigger: "blur",
        },
        provinceId: {
          required: true,
          message: "请选择所在地区",
          trigger: "change",
        },
        corName: {
          required: true,
          message: "请输入法定代表人",
          trigger: "blur",
        },
        corMobile: {
          required: true,
          message: "请输入法定代表人电话",
          trigger: "blur",
        },
        businessZoneId: {
          required: true,
          message: "请选择业务区域",
          trigger: "change",
        },
        businessPersonId: {
          required: true,
          message: "请选择业务员",
          trigger: "change",
        },
        directorIdCard: { validator: validateIdCard, trigger: "blur" },
        directorMobile: { validator: validateMobile, trigger: "blur" },
      },
      previewImgUrl: "", //预览图片url
      previeImgVisible: false, //预览图片弹框
      submitFlag: false,
      refusePopVisible: false, //拒绝弹框显示/隐藏
      refuseForm: {
        auditRemark: "",
      },
      refuseRules: {
        auditRemark: {
          required: true,
          message: "请输入拒绝原因",
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    checkedRegionData(newVal) {
      this.form.provinceId = newVal[0] || "";
      this.form.cityId = newVal[1] || "";
      this.form.areaId = newVal[2] || "";
      let regionNames =
        newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
      this.form.provinceName = regionNames[0];
      this.form.cityName = regionNames[1];
      this.form.areaName = regionNames[2];
      if (newVal.length > 0) {
        this.$refs["form"].clearValidate("provinceId");
      }
    },
    // checkedZone(newVal) {
    //   this.form.businessZoneId = newVal.length > 0 ? newVal[newVal.length - 1] : "";
    //   newVal.length > 0 && this.getDutyPerson();
    // },
  },
  created() {
    this.cooApplyId = this.$route.query.cooApplyId;
    this.getCooperativeApplyInfo();
  },
  beforeRouteEnter(to, from, next) {
    let targetPath = "";
    switch (to.query.dataSource) {
      case "2":
        targetPath = "/cooperative/apply-examine/list";
        break;
      case "3":
        targetPath = "/cooperative/apply-examine/batch";
        break;
    }
    to.meta.targetPath = targetPath;
    next((vm) => {});
  },
  methods: {
    zoneChange(newVal) {
      this.form.businessPersonId = "";
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    // 拒绝
    handleRefuse() {
      this.refusePopVisible = true;
      this.refuseForm.auditRemark = "";
    },
    refuseSubmit() {
      this.$refs.refuseForm.validate((valid, object) => {
        if (valid) {
          this.form.auditRemark = this.refuseForm.auditRemark;
          this.cooperativeAudit(3);
          this.refusePopVisible = false;
        }
      });
    },
    // 获取审核信息
    getCooperativeApplyInfo() {
      this.$http.cooperative
        .getCooperativeApplyInfo({ cooApplyId: this.cooApplyId })
        .then((res) => {
          this.form = { ...this.form, ...res.data };
          this.getBusinessZoneData();
          let { provinceId, cityId, areaId } = res.data;
          if (provinceId && cityId) {
            // 地区回显赋值
            let checkedRegionData = [provinceId, cityId];
            areaId && checkedRegionData.push(areaId);
            this.checkedRegionData = checkedRegionData;
          }
          // 业务区域有值时 获取业务员数据
          res.data.businessZoneId && this.getDutyPerson();

          //荣誉证书和经营场地回显赋值
          if (
            res.data.cooHonorFileList &&
            res.data.cooHonorFileList.length > 0
          ) {
            let honorFileList = res.data.cooHonorFileList.map((item) => {
              return {
                id: item.id,
                applyId: item.applyId,
                fileType: 2,
                url: item.picPath,
                name: item.fileName,
                status: "success",
              };
            });
            this.honorFileList = JSON.parse(JSON.stringify(honorFileList));
            this.cooHonorFileList = JSON.parse(JSON.stringify(honorFileList));
          }
          if (
            res.data.cooBusinessPlaceFileList &&
            res.data.cooBusinessPlaceFileList.length > 0
          ) {
            let premisesFileList = res.data.cooBusinessPlaceFileList.map(
              (item) => {
                return {
                  id: item.id,
                  applyId: item.applyId,
                  fileType: 3,
                  url: item.picPath,
                  name: item.fileName,
                  status: "success",
                };
              }
            );
            this.premisesFileList = JSON.parse(
              JSON.stringify(premisesFileList)
            );
            this.cooBusinessPlaceFileList = JSON.parse(
              JSON.stringify(premisesFileList)
            );
          }
        });
    },
    // 根据地区id查询name
    handleRegionName(ids) {
      let province = this.regionData.filter((item) => item.i == ids[0])[0];
      let city = province.c.filter((item) => item.i == ids[1])[0];
      let areaName = ids[2]
        ? city.c.find((item) => item.i == ids[2])
          ? city.c.find((item) => item.i == ids[2]).n
          : ""
        : "";
      return [province.n, city.n, areaName];
    },
    // 根据最后一级业务区域id查找完整id-用于页面回显
    handleZoneIds(list, id, zoneIds) {
      if (!zoneIds) zoneIds = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        zoneIds.push(item.id);
        if (item.id == id) return zoneIds;
        if (item.children && item.children.length > 0) {
          return this.handleZoneIds(item.children, id, zoneIds);
        }
      }
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        let data = res.data;
        this.businessZoneList = data;
        let businessZoneId = this.form.businessZoneId;
        // 业务区域回显赋值
        if (businessZoneId) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id == businessZoneId) {
              this.checkedZone = [businessZoneId];
              break;
            } else {
              if (data[i].children && data[i].children.length > 0) {
                this.checkedZone = this.handleZoneIds(
                  data[i].children,
                  businessZoneId,
                  [data[i].id]
                );
              }
            }
          }
        }
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 身份证识别
    disIdcard(imageUrl, type) {
      let LoadingInstance = this.$loading({
        target: document.getElementById(type),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disIdcard({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          this.form[type] = imageUrl;
          if (type == "cardPortraitUrl") {
            let cards = res.data.cards;
            this.form.directorName = cards.name;
            this.form.directorIdCard = cards.id_num;
            this.form.directorAddress = cards.address;
          }
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    //营业执照识别
    disBusinessLicense(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("businessLicense"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disBusinessLicense({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          let license = res.data.license;
          this.form.cooperativeName = license.name;
          this.form.socialCreditCode = license.reg_num;
          this.form.corName = license.legal_person;
          this.form.address = license.address;
          this.form.registeredCapital = license.capital;
          this.form.foundingTime = license.start_date;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    //提交
    handleSubmit(formName, handleType) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.cooperativeAudit(handleType);
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (dom) {
              if (Object.prototype.toString.call(dom) !== "[object Object]") {
                //这里是针对遍历的情况（多个输入框），取值为数组
                dom = dom[0];
              }
              dom.$el.scrollIntoView({
                //滚动到指定节点
                block: "end", //值有start,center,end，nearest，当前显示在视图区域中间
                behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
              });
            }
          }
          this.submitFlag = false;
          return false;
        }
      });
    },
    // 审核操作
    cooperativeAudit(handleType) {
      this.submitFlag = true;
      this.form.auditType = handleType;
      let cooHonorFileList = this.cooHonorFileList.map((item) => {
        return {
          id: item.id || "",
          applyId: item.applyId || "",
          fileName: item.name,
          picPath: item.url,
          fileType: 2,
        };
      });
      let cooBusinessPlaceFileList = this.cooBusinessPlaceFileList.map(
        (item) => {
          return {
            id: item.id || "",
            applyId: item.applyId || "",
            fileName: item.name,
            picPath: item.url,
            fileType: 3,
          };
        }
      );
      let params = {
        ...this.form,
        cooHonorFileList: cooHonorFileList,
        cooBusinessPlaceFileList: cooBusinessPlaceFileList,
      };
      this.$http.cooperative
        .cooperativeAudit(params)
        .then((res) => {
          this.$message.success("审核成功");
          this.$router.go(-1);
          this.submitFlag = false;
        })
        .catch((err) => {
          this.submitFlag = false;
        });
    },
    //预览图片
    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },
    // 删除图片
    handleRemoveImg(file, type) {
      let url = file.response ? file.response.url : file.url;
      switch (type) {
        case "honor":
          this.cooHonorFileList = this.cooHonorFileList.filter(
            (item) => item.url != url
          );
          break;
        case "premises":
          this.cooBusinessPlaceFileList = this.cooBusinessPlaceFileList.filter(
            (item) => item.url != url
          );
          break;
      }
    },
    handleExceed() {
      this.$message.warning("最多只能上传10个文件，请删除后在上传");
    },
    //自定义上传
    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
        })
        .catch((err) => {
          content.onError(err);
        });
    },
    //图片上传成功
    handleImgSuccess(file, type) {
      switch (type) {
        case "businessLicenseUrl":
          this.form.businessLicenseUrl = file.url;
          this.disBusinessLicense(file.url);
          break;
        case "cardPortraitUrl":
          this.disIdcard(file.url, "cardPortraitUrl");
          break;
        case "cardEmblemUrl":
          this.disIdcard(file.url, "cardEmblemUrl");
          break;
        case "directorHeadUrl":
          this.form.directorHeadUrl = file.url;
          break;
        case "honor":
          this.cooHonorFileList.push({
            id: "",
            applyId: "",
            fileType: 2,
            url: file.url,
            name: file.title,
          });
          break;
        case "premises":
          this.cooBusinessPlaceFileList.push({
            id: "",
            applyId: "",
            fileType: 3,
            url: file.url,
            name: file.title,
          });
          break;
      }
    },
    /**
     * @description: 打开定位地图
     * @Author: quwandong
     * @Date: 2022-12-29 11:33:13
     */
    openQueryMap() {
      const checkedNodes = this.$refs.regionCascader.getCheckedNodes();
      let checkedRegionStr = "";
      if (checkedNodes[0]) {
        checkedRegionStr = checkedNodes[0].pathLabels.join("");
      }
      this.$refs.queryMap.openDialog(checkedRegionStr);
    },
    /**
     * @description:
     * @param {*} address
     * @Author: quwandong
     * @Date: 2022-12-29 11:35:51
     */
    onConfirmSelectAddress(addressDetail) {
      this.centreAddress = addressDetail.name
        ? addressDetail.address + addressDetail.name
        : addressDetail.address;
      this.form.centre = `${addressDetail.lonlat.lng},${addressDetail.lonlat.lat}`;
      this.$refs.form.validateField("centre");
    },
  },
};
